export const REDUCER_NAME = "competitionClubs";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_COMPETITIONCLUBS = `${REDUCER_NAME}/SET_COMPETITIONCLUBS`;
export const RESET_COMPETITIONCLUBS = `${REDUCER_NAME}/RESET_COMPETITIONCLUBS`;
